import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import MessageTableRow from "./MessageTableRow";
import LoadingSpinner from "./LoadingSpinner";

const MessageList = () => {
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        axios
            .get("https://peaceo.hopto.org/messages")
            .then(({ data }) => {
                setIsLoading(false);
                setMessages(data);
                // window.location.reload();
                // setTimeout(() => window.location.reload());
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
            });
    }, []);

    const DataTable = () => {
        return messages.map((res, i) => {
            return <MessageTableRow obj={res} key={i} />;
        });
    };

    return (
        <div className="table-wrapper">
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Message</th>
                        <th>Event</th>
                        <th>Progress Result</th>
                    </tr>
                </thead>
                {isLoading ? <LoadingSpinner /> : <tbody>{DataTable()}</tbody> }
            </Table>

        </div>
    );
};

export default MessageList;